import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const claimPromotion = createAsyncThunk(
  "claimPromotion/claimPromotion",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("promotion/get-redirection", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const promotionClaimSlice = createSlice({
  name: "claimPromotion",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(claimPromotion.pending, (state) => {
        state.loading = true;
      })
      .addCase(claimPromotion.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(claimPromotion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default promotionClaimSlice.reducer;
